import React, {useEffect, useState} from "react";
import {IItemContent} from "@connox/typescript-library";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import {localCache} from "./BoughtTogetherPortal";
import SwiperConstruct, {BreakpointType} from "./SwiperConstruct";

const BasketModalBoughtTogetherSwiper: React.FC<{itemId: number}> = ({itemId}) => {
  const [items, setItems] = useState<IItemContent[]>([]);
  const {customer} = useCustomerSelector();
  const {t} = useTranslation();

  useEffect(() => {
    if (localCache) {
      setItems(localCache);
    } else {
      const paUrl = `${paMainUrl}BoughtTogether?productRef=${itemId}&filterOutOfStock=false`;
      void retrieveItemContent(paUrl, customer).then(setItems);
    }
  }, []);

  if (!items.length) {
    return null;
  }

  const breakpoints: BreakpointType = {
    481: {
      slidesPerView: 2.5,
    },
  };

  return (
    <SwiperConstruct
      items={items}
      title={t("product.customersAlsoBought")}
      breakpoints={breakpoints}
      isCartSwiper={true}
    />
  );
};

export default BasketModalBoughtTogetherSwiper;
